const namespace = 'AUDITED_FINANCIALS_';

export const CONSTANTS = {
    GET_AUDITED_FINANCIALS_REPORT_ID: `${namespace}GET_AUDITED_FINANCIALS_REPORT_ID`,
    GET_AUDITED_FINANCIALS_REPORT_ID_SUCCESS: `${namespace}GET_AUDITED_FINANCIALS_REPORT_ID_SUCCESS`,
};
